import React, {useEffect, useState, useCallback, Fragment, useRef} from "react"
import {useDispatch, useSelector} from "react-redux"
import moment from "moment"
import _ from "lodash"
import {useAuth0} from "@auth0/auth0-react"
import _orderBy from "lodash/orderBy"

// UI

import {Card} from "@uprise/card"
import {spacing} from "@uprise/spacing"
import {H4} from "@uprise/headings"
// Components
import ComponentWrapper from "components/HOC/ComponentWrapper"
import TableComponent, {PAGE_SIZE} from "components/shared/Table"
import TableSortOrder from "components/shared/TableSortOrder"
import DropDown from "components/shared/DropDown"
import NotesModal from "./NotesModal"
import EmailModal from "./EmailModal"
import {Modal} from "@uprise/modal"
import {Alerts} from "./Alerts"
import {ModalButtonContainer} from "features/Bookings/AllBookingsTable/index.style"
import RCBDetails from "features/RiskCallBacks/RCBDetails"
// Styles
import {
	HeaderTableContent,
	AssignTimeContainer,
	AssignTimeInput,
	AssigneTimeCloseButton,
	CommunicateButton,
	SearchUserInput,
	StatusRowContainer,
	StatusRowSpan,
	StatusRowTest,
	RowClickableText,
	FigureIcon,
	NoteTextArea,
	SearchInputContainer,
	SearchInputfigure,
	SearchInputImage,
	ManageBtn
} from "./index.style"
import {ColumnContainer} from "shared/Table/index.style"

// slices
import {authSelector} from "features/Auth/authSlice"
import {
	userDataSelector,
	fetchUsersByEmail,
	fetchBookingsByUserEmail,
	fetchSessionDetailsByUser,
	fetchCodeCaps
} from "features/Users/usersSlice"
import {fetchEmployerByCode, employerSelector} from "features/Employers/employerSlice"
import {fetchCoaches, bookingDataSelector} from "features/Bookings/bookingSlice"

import {
	fetchRiskCallbackData,
	fetchRiskCallbackNote,
	riskCallbackDataSelector,
	assignRiskcallbackToUser,
	closeRiskCallback,
	openEmailModal,
	closeEmailModal,
	saveRiskCallbackNotes,
	openNoteModal,
	closeNoteModal,
	clearSendRiskCallbackEmailApiState,
	clearRiskCallBackApiState
} from "./riskCallbackSlice"

import OvalIcon from "assets/images/icons/svg/oval.svg"
import OvalClosedIcon from "assets/images/icons/svg/oval-closed.svg"
import NoteIcon from "assets/images/icons/svg/note-icon.svg"
import IconSearch from "assets/images/icons/svg/search.svg"

const RiskCallBack = ({user, history}) => {
	const dispatch = useDispatch()

	const [usersData, setUsersData] = useState([])
	const [filteredData, setFilteredData] = useState([])
	const [coachesData, setCoachesData] = useState([])
	const [pageCount, setPageCount] = useState(0)
	const [selectedUser, setSelectedUser] = useState({})
	const [searchTerm, setSearchTerm] = useState("")
	const [token, setToken] = useState("")
	const [callsRemaining, setCallsRemaining] = useState(0)
	const [therapyCallsRemaining, setTherapyCallsRemaining] = useState(0)
	const [showRcbModal, setShowRcbModal] = useState(false)
	const [selectedRcb, setSelectedRcb] = useState({})
	const [codeExpired, setCodeExpired] = useState(false)
	const [assignedCoach, setAssignedCoach] = useState()
	const [loading, setLoading] = useState(-1)
	const [selectedCoach, setSelectedCoach] = useState("")
	const [pageNo, setPageNo] = useState(0)

	const fetchIdRef = useRef(0)
	const searchRef = useRef("")
	const authState = useSelector(authSelector)

	const {
		modalState,
		saveRiskCallbackNotesApiState,
		sendRiskCallbackEmailApiState,
		assignRiskcallbackToUserApiState,
		closeRiskCallBackApiState,
		riskCallBackApiState,
		riskCallBackNoteApiState,
		saveRiskCallbackDetailsApiState
	} = useSelector(riskCallbackDataSelector)
	const {fetchCoachesApiState} = useSelector(bookingDataSelector)

	const {getAccessTokenSilently} = useAuth0()

	const [emailContent, setEmailContent] = useState({
		id: "",
		email: "",
		subject: "",
		body: ""
	})

	const {selectedEmployerDetails} = useSelector(employerSelector)
	const {bookings, fetchSessionDetailsApiState, profile, fetchCodeCapsApiState} = useSelector(userDataSelector)

	useEffect(() => {
		async function fetchToken() {
			const token = await getAccessTokenSilently()
			setToken(token)
		}

		fetchToken()
	}, [])

	useEffect(() => {
		// Clear state on unmount
		return () => dispatch(clearRiskCallBackApiState())
	}, [])

	useEffect(() => {
		if (riskCallBackApiState?.users?.length > 0) {
			let updateSelectedUser = riskCallBackApiState.users.find(user => selectedUser && user.id == selectedUser.id)

			setSelectedUser(updateSelectedUser ? updateSelectedUser : {})
			setUsersData(riskCallBackApiState.users)
		}

		setUsersData(riskCallBackApiState.users)
		if (riskCallBackApiState?.coaches?.length > 0) {
			setCoachesData(riskCallBackApiState.coaches)
		}
	}, [riskCallBackApiState])

	useEffect(() => {
		if (riskCallBackApiState.totalCount) {
			setPageCount(Math.ceil(riskCallBackApiState.totalCount / PAGE_SIZE))
		}
	}, [riskCallBackApiState.totalCount])

	useEffect(() => {
		const {coachingCallCap, therapyCallCap, startingDate, combined} = fetchCodeCapsApiState
		let future = [],
			past = [],
			cancelled = [],
			f2f = []
		let therapyBookings = []
		let totalValidBookings =
			bookings
				?.filter(booking => {
					return booking?.id
				})
				.filter(booking => moment(booking.createdAt).diff(moment(startingDate), "days") >= 0)
				.filter(booking => {
					if (["within24", "within_24", "userNoShow", "user_no_show"].includes(booking.cancelReason))
						return true
					else return !booking.cancelled
				}) || []

		bookings?.map(booking => {
			if (booking.cancelled) {
				cancelled.push(booking)
			} else if (booking.type === "F2F") f2f.push(booking)
			else if (moment(booking.start).unix() >= moment().unix()) future.push(booking)
			else past.push(booking)
		})

		const totalBookings = [...totalValidBookings]

		//therapy and coaching calls counted separately
		therapyBookings = totalValidBookings.filter(booking => booking.duration === 60)
		totalValidBookings = totalValidBookings.filter(booking => booking.duration === 30)

		if (!selectedEmployerDetails?.caps?.capCalls) {
			setCallsRemaining("unlimited")
			setTherapyCallsRemaining("unlimited")
		} else {
			if (combined) {
				setCallsRemaining(parseInt(coachingCallCap) - totalBookings.length)
				setTherapyCallsRemaining(parseInt(coachingCallCap) - totalBookings.length)
			} else {
				setCallsRemaining(parseInt(coachingCallCap) - totalValidBookings.length)
				setTherapyCallsRemaining(parseInt(therapyCallCap) - therapyBookings.length)
			}
		}
		setCodeExpired(moment().isAfter(moment(selectedEmployerDetails.expiryDate)))
	}, [bookings, fetchCodeCapsApiState, selectedEmployerDetails])

	useEffect(() => {
		async function fetchToken() {
			const token = await getAccessTokenSilently()
			dispatch(fetchCodeCaps({token, code: profile.employerCode}))
			setToken(token)
		}
		if (profile?.employerCode) fetchToken()
	}, [profile])

	const onCancel = () => {
		setShowRcbModal(false)
	}

	const fetchData = useCallback(
		({pageSize, pageIndex}) => {
			// This will get called when the table needs new data
			// You could fetch your data from literally anywhere,
			// even a server. But for this example, we'll just fake it.

			// Give this fetch an ID
			const fetchId = ++fetchIdRef.current

			if (searchRef.current !== searchTerm) {
				pageIndex = 0
			}

			setPageNo(pageIndex)

			if (fetchId === fetchIdRef.current && token) {
				dispatch(
					fetchRiskCallbackData({
						limit: pageSize,
						skip: pageSize * pageIndex,
						token,
						coachId: selectedCoach,
						searchTerm: searchTerm
					})
				)
			}

			searchRef.current = searchTerm
		},
		[token, selectedCoach, searchTerm]
	)

	const handleSearchChange = useCallback(
		_.debounce(
			value => {
				setSearchTerm(value)
			},
			1500,
			{maxWait: 1500}
		),
		[]
	)

	const handleModalClose = () => {
		dispatch(closeEmailModal())
	}

	const handleNoteModalClose = () => {
		dispatch(closeNoteModal())
	}

	const _handleNoteSave = user => {
		const coachId = authState?.data?.id

		if (token.length) {
			dispatch(saveRiskCallbackNotes({id: user.id, coachId, email: user.email, note: user.value, token}))
			dispatch(closeNoteModal())
		}
	}

	const onCoachFilterChange = e => {
		setSelectedCoach(e.value)
		const filteredData = riskCallBackApiState.users.filter(item => item.data.coachId == e.value)
		setFilteredData(filteredData)
	}

	const onActiveFilterChange = e => {
		if (e.value === 2) {
			setFilteredData([])
		} else {
			const filteredData = usersData.filter(item => item.statusId == e.value)
			setFilteredData(filteredData)
		}
	}

	const AssignTimeAndCloseComponent = ({id, row}) => {
		const [duration, setDuration] = useState(null)
		const onCloseRiskCallback = () => {
			if (!duration) {
				alert("Please set duration")
				return
			}
			dispatch(closeRiskCallback({id, duration, token}))
		}

		return (
			<AssignTimeContainer>
				{row.data.duration ? (
					<div>{row.data.duration} Mins</div>
				) : (
					<React.Fragment>
						<AssignTimeInput type='text' onChange={e => setDuration(e.target.value)} />
						<p>Min</p>
						<AssigneTimeCloseButton title={"Close"} variant={"primary"} onClick={onCloseRiskCallback} />
					</React.Fragment>
				)}
			</AssignTimeContainer>
		)
	}

	const Communicate = ({id, row}) => {
		const body = `Dear ${row.data.name},\n\nAt Uprise, all our users and your wellbeing matter to us.\n\nWe noticed that you recently completed your Wellbeing Check. Thank you for taking the time to do this. We appreciate it!\n\nAs your wellbeing score came a little lower, one of our clinicians would like to give you a call to check in and see if there's any further support we can offer.\n\nI am sending this as a heads-up as we understand that a call from an unknown or blocked number isn't always convenient and can sometimes raise an "is this a scam?" flag, which is a fair concern, and we want to respect your time and privacy.\n\nSince busy schedules and time zones, especially with daylight saving across Australia, vary, let us know if there's a time that suits you better (morning, afternoon or evening), and we'll do our best to call then.\n\nYou can expect a call from us today, but if you'd prefer we call at a specific date and time, reply to this email and we'll arrange it.\n\nWe hope to connect with you soon.\n\nKind regards,\n${authState.data.name}`

		const onSendEmailClick = row => {
			setEmailContent({
				id: id,
				email: row.data.email,
				subject: "A Quick Check-In from the Uprise Team",
				body
			})
			dispatch(openEmailModal())
		}
		return (
			<CommunicateButton
				align='center'
				title={row.data.isMailSend ? "Re-Send" : "Send email"}
				variant={"secondary"}
				onClick={() => onSendEmailClick(row)}
			/>
		)
	}

	useEffect(() => {
		getAssignedCoach()
	}, [profile])

	const getAssignedCoach = () => {
		const coach = profile?.coach
		if (coach) setAssignedCoach(coach)
		else if (!bookings.length) return
		else {
			const lastBooking = [...bookings].reverse().find(book => !book.cancelled)
			setAssignedCoach(lastBooking?.coachEmail)
		}
	}

	const handleManage = async (row, id) => {
		setLoading(id)
		const token = await getAccessTokenSilently()

		await dispatch(fetchUsersByEmail({email: row.email, token}))
		await dispatch(fetchBookingsByUserEmail({userEmail: row.email, token}))
		await dispatch(fetchCoaches({token: token}))
		await dispatch(
			fetchSessionDetailsByUser({
				email: row.data.email,
				token
			})
		)
		await dispatch(fetchRiskCallbackNote({id: row.id, token}))
		await dispatch(fetchEmployerByCode({code: row.code, token}))

		setSelectedRcb(row)
		setShowRcbModal(true)
		setLoading(-1)
	}

	const StatusRow = ({id, row}) => {
		return (
			<StatusRowContainer>
				<StatusRowSpan>
					<img src={row.status === "Active" ? OvalIcon : OvalClosedIcon} />
				</StatusRowSpan>
			</StatusRowContainer>
		)
	}

	const Notes = ({id, row, align}) => {
		const _handleNoteClick = row => {
			dispatch(fetchRiskCallbackNote({id: row.id, token}))

			setSelectedUser({id: row.id, name: row.data.name, email: row.email, notes: row.data.notes})
			dispatch(openNoteModal())
		}
		return (
			<FigureIcon align={align} onClick={() => _handleNoteClick(row)}>
				<img src={NoteIcon} alt={""} id={id} row={row} />
			</FigureIcon>
		)
	}

	const TherapistsDropDown = ({id, coachId, coaches}) => {
		const selectedCoach = coaches.filter(coach => coach.value === coachId)

		const onChange = (id, e) => {
			const coachId = e.value

			if (token) {
				dispatch(assignRiskcallbackToUser({id, coachId, token}))
			}
		}

		const dropdown = (
			<DropDown
				containerStyle={{
					alignSelf: "center",
					marginRight: "12px",
					position: "relative"
				}}
				initialSelectedItem={selectedCoach[0]}
				label='Select Coach'
				onChange={e => onChange(id, e)}
				menuStyle={{position: "absolute", zIndex: 2}}
				items={coaches}
			/>
		)

		return <div>{dropdown}</div>
	}

	const columns = [
		{
			Header: "Name",
			accessor: "name",
			width: "125px",
			show: true,
			sortType: "string",
			Cell: cellInfo => {
				return (
					<RowClickableText
						onClick={() => {
							history.push(`/users/${cellInfo.row.original.email}`)
						}}>
						{cellInfo.row.original.name}
					</RowClickableText>
				)
			}
		},
		{
			Header: "Email Address",
			accessor: "email",
			show: true,
			sortType: "string"
		},
		{
			Header: "Employer",
			width: "75px",
			accessor: d => {
				if (d?.code) {
					return d.code
				}

				return null
			},
			show: true,
			sortType: "string",
			Cell: cellInfo => {
				return (
					<RowClickableText
						onClick={() => {
							history.push(`/employer/${cellInfo.row.original.code}`)
						}}>
						{cellInfo.row.original.code}
					</RowClickableText>
				)
			}
		},
		{
			Header: "Date/Time of Check",
			accessor: "createdAt",
			show: true,
			desc: true,
			sortType: (a, b) => {
				return a.original.createdAt.localeCompare(b.original.createdAt)
			},
			Cell: ({cell: {value}}) => {
				return <Fragment>{value ? <div>{moment(value).format("Do MMMM YYYY hh:mm a")}</div> : "-"}</Fragment>
			}
		},
		//{
		//	Header: "Wellbeing Therapist",
		//	disableSortBy: true,
		//	accessor: "progress",
		//	show: true,
		//	style: {overflow: "auto"},
		//	Cell: e => {
		//		return (
		//			<TherapistsDropDown id={e.row.original.id} coachId={e.row.original.coachId} coaches={coachesData} />
		//		)
		//	}
		//},
		{
			Header: "State",
			width: "40px",
			accessor: "status",
			show: true,
			Cell: e => {
				return <StatusRow id={e.row.original.id} row={e.row.original} />
			}
		},
		{
			Header: "Actions",
			disableSortBy: true,
			width: "95px",
			Cell: cellInfo => (
				<ColumnContainer align='space-around'>
					<Communicate id={cellInfo.row.original.id} row={cellInfo.row.original} />
					<ManageBtn
						title='Manage'
						size='medium'
						variant='tertiary'
						onClick={() => handleManage(cellInfo.row.original, cellInfo.row.id)}
						isLoading={loading === cellInfo.row.id}
					/>
				</ColumnContainer>
			)
		}
		/*
		{
			Header: "Assign time & close",
			// accessor: "",
			Cell: cellInfo => <AssignTimeAndCloseComponent id={cellInfo.row.original.id} row={cellInfo.row.original} />,
			show: true,
			disableSortBy: true
		},
		{
			Header: "Notes",
			width: "50px",
			accessor: "notes",
			Cell: cellInfo => <Notes align='center' id={cellInfo.row.original.id} row={cellInfo.row.original} />,
			show: true,
			disableSortBy: true
		}
		*/
	]

	return (
		<ComponentWrapper
			menuActiveIndex={6}
			headerTitle='Risk Callback'
			headerRightAlignContent={
				<HeaderTableContent>
					<SearchInputContainer>
						<SearchInputfigure>
							<SearchInputImage src={IconSearch} />
						</SearchInputfigure>
						<SearchUserInput
							type={"text"}
							label={"email"}
							//value={searchTerm}
							onChange={e => handleSearchChange(e.target.value)}
							//onChange={e => _handleSearchEmployerCodeChange(e.target.value)}
							placeholder={"Search by email, name or employer code"}
							data-testid='searchUserEmail'
							isRequired={false}
						/>{" "}
						<DropDown
							containerStyle={{
								alignSelf: "center",
								marginRight: "12px",
								position: "relative",
								zIndex: "2"
							}}
							label='Select Coach'
							onChange={onCoachFilterChange}
							menuStyle={{position: "absolute"}}
							items={coachesData}
							isLast={true}
						/>
						<DropDown
							label='Filter By'
							containerStyle={{
								alignSelf: "center",
								marginRight: "12px",
								position: "relative",
								zIndex: "2"
							}}
							onChange={onActiveFilterChange}
							menuStyle={{position: "absolute"}}
							items={[
								{label: "All", value: 2},
								{label: "Active", value: 1},
								{label: "In Active", value: 0}
							]}
							isLast={true}
						/>
					</SearchInputContainer>
				</HeaderTableContent>
			}>
			<Alerts
				className='m-b-5'
				closeRiskCallBackApiState={closeRiskCallBackApiState}
				assignRiskcallbackToUserApiState={assignRiskcallbackToUserApiState}
				saveRiskCallbackNotes={saveRiskCallbackNotes}
				saveRiskCallbackNotesApiState={saveRiskCallbackNotesApiState}
				sendRiskCallbackEmailApiState={sendRiskCallbackEmailApiState}
				saveRiskCallbackDetailsApiState={saveRiskCallbackDetailsApiState}
			/>

			<Card padding={spacing.s10} backgroundColor='white' data-testid='riskCallBackData'>
				<TableComponent
					columns={columns}
					pageCount={pageCount}
					fetchData={fetchData}
					pageNo={pageNo}
					data={usersData}
					loading={riskCallBackApiState.isFetching || !riskCallBackApiState.isSuccess}
				/>
			</Card>

			<EmailModal
				isOpen={modalState.sendEmailModalState}
				handleClose={handleModalClose}
				emailContent={emailContent}
				token={token}
			/>
			<NotesModal
				isOpen={modalState.noteModalState}
				notes={selectedUser.notes}
				onSave={_handleNoteSave}
				user={selectedUser}
				onClose={handleNoteModalClose}
			/>
			<Modal
				isOpen={showRcbModal}
				handleClose={onCancel}
				padding={"24px 0"}
				backgroundColor={"#ffffff"}
				width={"70%"}
				scroll={true}
				textAlign='center'>
				<H4>{`Risk Callback Details`}</H4>
				<ModalButtonContainer>
					<RCBDetails
						onCancel={onCancel}
						rcbNotes={riskCallBackApiState}
						rcbNote={riskCallBackNoteApiState.note}
						coachingRemaining={callsRemaining + " remaining"}
						therapyRemaining={therapyCallsRemaining + " remaining"}
						rcb={selectedRcb}
						codeExpired={codeExpired}
						wellbeingTherapists={coachesData}
						sessionNotes={fetchSessionDetailsApiState.data}
						coaches={fetchCoachesApiState.data}
						assignedCoach={assignedCoach}
					/>
				</ModalButtonContainer>
			</Modal>
		</ComponentWrapper>
	)
}

export default RiskCallBack
